import { ICollaborationDataSource } from '@cscglobal-tbs/collaboration-ui';
import { AddNewConversationRequest, UpdateConversationRequest } from '../model';
import { useCommentDataItemsForReport } from './useCommentDataItemsForReport';

export const useReportCommentsDataSource = (reportId: string, reportName?: string): ICollaborationDataSource => {
    const {
        isLoadingItems,
        isFetchingItems,
        isErrorItems,
        items,
        mutateAsync,
        updateConversationAsync,
        deleteConversationAsync,
        resolveConversationAsync,
        reopenConversationAsync,
        addReplyAsync,
        updateReplyAsync,
        deleteReplyAsync,
        refetchItems,
    } = useCommentDataItemsForReport(reportId);

    const processUpdateConversationAsync = async (data: UpdateConversationRequest) => {
        data.reportName = reportName;
        await updateConversationAsync({ data });
    };

    const addConversationAsync = async (data: AddNewConversationRequest) => {
        data.reportName = reportName;
        await mutateAsync({ reportId, data });
    };

    return {
        isLoadingItems,
        isFetchingItems,
        isErrorItems,
        items: items || [],
        refetchItems,
        addConversationAsync,
        updateConversationAsync: processUpdateConversationAsync,
        deleteConversationAsync: async (data) => {
            await deleteConversationAsync(data);
        },
        resolveConversationAsync: async (data) => {
            await resolveConversationAsync(data);
        },
        reopenConversationAsync: async (data) => {
            await reopenConversationAsync(data);
        },
        addReplyAsync: async (data) => {
            await addReplyAsync(data);
        },
        updateReplyAsync: async (data) => {
            await updateReplyAsync(data);
        },
        deleteReplyAsync: async (data) => {
            await deleteReplyAsync(data);
        },
    };
};
